<template>
  <modal
    name="commitReviewConfirm"
    transition="nice-modal-fade"
    :pivotY="0.3"
    :classes="[]"
    :clickToClose="false"
    @before-open="beforeOpen"
    @opened="isShow = true;"
    @closed="isShow = false;"
  >
    <div class="rootDom">
      <div class="titleDom">
        <span class="title">{{title}}</span>
        <div class="close-btn" v-if="showCloseBtn" @click="hide('Close')">
          <i class="icon-popup-close"></i>
        </div>
      </div>
      <div class="contentDom">
        <span class="content">{{content}}</span>
        <div class="btnDom" v-if="btns && btns.length>0">
          <div
            v-for="(btn,index) in btns"
            :key="index"
            class="button"
            :class="[btn.className]"
            @click="handBtnClick(btn.type)"
          >{{btn.content}}</div>
        </div>
        <el-checkbox style="margin-top:20px;" v-model="isChecked">之后不再提醒</el-checkbox>
      </div>
    </div>
  </modal>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "commitReviewConfirm",
  data() {
    return {
      isChecked: true,
      waiting: false,
      isShow: false,

      title: "", //标题
      content: "", //内容
      btns: [], //按钮
      showCloseBtn: true, //是否显示关闭按钮
      resultHandler: null, //事件处理函数

      pre_defined_btns: {
        Ok: { type: "Ok", content: "提交审核", className: "button-Ok" },
        Cancel: { type: "Cancel", content: "取消", className: "button-Cancel" },
        Delete: { type: "Delete", content: "删除", className: "button-Delete" }
      }
    };
  },
  props: {},
  components: {},
  methods: {
    beforeOpen(ev) {
      this.init();

      this.title = ev.params.title;
      this.content = ev.params.content;
      let inputBtns = ev.params.btns || [];

      for (const key in inputBtns) {
        let btn = inputBtns[key];
        if (typeof btn == "object") {
          if (btn.hasOwnProperty("type") && btn.hasOwnProperty("content")) {
            btn.className = "button-Customize";
            this.btns.push(btn);
          }
        } else if (typeof btn == "string") {
          if (this.pre_defined_btns[btn]) {
            this.btns.push(this.pre_defined_btns[btn]);
          } else if (btn === "Close") {
            this.showCloseBtn = true;
          }
        }
      }
      if (typeof ev.params.resultHandler == "function") {
        this.resultHandler = ev.params.resultHandler;
      }
    },
    init() {
      this.title = ""; //标题
      this.content = ""; //内容
      this.btns = []; //按钮
      this.showCloseBtn = false; //是否显示关闭按钮
      this.resultHandler = null; //事件处理函数
    },
    handBtnClick(type) {
      this.hide(type);
    },
    hide(type) {
      this.$modal.hide("commitReviewConfirm");
      if (type === "Ok" && this.isChecked) {
        Cookies.set("laihua_commitReviewConfirm_ignore", "true", {
          expires: 366,
          path: "/"
        });
      }
      if (this.resultHandler) {
        this.resultHandler(type);
      }
      this.init();
    }
  },
  watch: {},
  computed: {}
};
</script>

<style scoped lang="scss">
.rootDom {
  position: relative;
  width: 540px;
  height: 264px;
  margin: auto;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;

  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 17px 40px 17px;
  justify-content: flex-start;

  .titleDom {
    position: relative;
    height: 40px;
    width: 100%;
    .title {
      display: inline-block;
      position: absolute;
      left: 0;
      font-size: 16px;
      line-height: 40px;
      text-align: left;
    }
    .close-btn {
      position: absolute;
      top: 14px;
      right: 0px;
      cursor: pointer;
    }
  }
  .contentDom {
    flex-grow: 1;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .content {
      width: 378px;
      display: inline-block;
      color: #333333;
      font-size: 14px;
      line-height: 30px;
    }
    .btnDom {
      margin-top: 20px;
      height: 40px;
      width: 362px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-shrink: 1;
      .button {
        width: 160px;
        height: 40px;
        border-radius: 8px;

        text-align: center;
        line-height: 40px;
        cursor: pointer;
        flex-shrink: 1;
      }
      .button-Ok {
        color: #fefefe;
        background-color: #5778fb;
        border-color: #5778fb;
      }

      .button-Cancel {
        background-color: #eaeaf6;
        border-color: #eaeaf6;
        color: #333;
      }
      .button-Delete {
        background-color: #ea3d45;
        border-color: #ea3d45;
        color: #fefefe;
      }

      .button-Customize {
        color: #fefefe;
        background-color: #5778fb;
        border-color: #5778fb;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/commitReviewConfirm.vue